/* tslint:disable */
/* eslint-disable */
/**
 * Munchi Dashboard Server Api
 * The Munchi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const Role = {
    ADMIN: 'ADMIN',
    MUNCHI_ADMIN: 'MUNCHI_ADMIN'
} as const;

export type Role = typeof Role[keyof typeof Role];



